import { useEffect, useRef, useState } from "react";

/**
 * Renders a single-line truncated span.
 * Shows a react-tooltip only when the text is actually overflowing.
 */
const TruncatedText = ({ value, className, tooltipId }) => {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setIsTruncated(el.scrollWidth > el.clientWidth);
    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <span
      ref={ref}
      className={className}
      data-tooltip-id={isTruncated ? tooltipId : undefined}
      data-tooltip-content={isTruncated ? value : undefined}
    >
      {value}
    </span>
  );
};

export { TruncatedText };
